import React from 'react';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { checkIsActive, KTSVG, toAbsoluteUrl } from '../../../helpers';

type Props = {
  to: string;
  title?: string | React.ReactNode;
  icon?: string;
  fontIcon?: string;
  hasArrow?: boolean;
  hasBullet?: boolean;
  logo?: boolean;
  rightBadge?: {
    title: string;
    variant?: 'light' | 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'dark';
    size?: 'sm' | 'md' | 'lg';
    className?: string;
  };
  onClick?: () => void;
  rightImage?: {
    src: string;
    className?: string;
  }
};

const MenuItem: React.FC<Props> = ({ to, title, icon, fontIcon, hasArrow = false, hasBullet = false, logo, rightBadge, onClick, rightImage }) => {
  const { pathname } = useLocation();

  return (
    <div className="menu-item me-lg-1">
      <Link
        className={clsx('fs-5 ', {
          active: checkIsActive(pathname, to) && !logo,
          ['menu-link py-3']: !logo,
        })}
        onClick={onClick}
        to={to}
      >
        {hasBullet && (
          <span className="menu-bullet">
            <span className="bullet bullet-dot"></span>
          </span>
        )}

        {icon && (
          <span className="menu-icon">
            {logo ? <img alt="Logo" className="h-35px logo svg-icon-5x" src={toAbsoluteUrl('/media/logos/logo-idefix.svg')} /> : <KTSVG path={icon} className="svg-icon-2" />}
          </span>
        )}

        {fontIcon && (
          <span className="menu-icon">
            <i className={clsx('bi fs-3', fontIcon)}></i>
          </span>
        )}

        <span className="menu-title">{title}</span>

        {hasArrow && <span className="menu-arrow"></span>}

        {rightImage ? (
          <span>
            <img alt="Logo" className={clsx('h-35px', rightImage.className)} src={toAbsoluteUrl(rightImage.src)} />
          </span>
        ) : null}

        {rightBadge ? (
          <span className={clsx('ms-2 badge badge-xs', `badge-${rightBadge.variant || 'light'}`, rightBadge?.size ? `badge-${rightBadge.size}` : '', rightBadge?.className)}>
            {rightBadge.title}
          </span>
        ) : null}
      </Link>
    </div>
  );
};

export { MenuItem };
